var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "card-pin-unpin-button" },
    [
      _c(
        "v-list-item",
        { staticClass: "text-center" },
        [
          _c("v-menu", {
            attrs: { "offset-y": "" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function(ref) {
                  return [
                    _c(
                      "v-btn",
                      {
                        staticClass: "pin-unpin-button",
                        attrs: { id: _vm.idPrefix + "_Pin", icon: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.pinUnpinCard($event)
                          }
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attr = ref.attr
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "material-icons-outlined",
                                              class: _vm.isPinned
                                                ? "unpin_icon"
                                                : ""
                                            },
                                            "v-icon",
                                            attr,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                push_pin\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { id: _vm.idPrefix + "_Pin_Tooltip" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isPinned
                                      ? "Unpin this card from my dashboard"
                                      : "Pin this card to my dashboard"
                                  ) + "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }